<template>
  <div class="box9">
    <pageTitle
      title="就业薪资高"
      text="博学谷学生多领域真项目实操，相当于累积1-3年工作经验"
    />
    <div class="content-box" @scroll="handleScroll">
      <div class="content" ref="content" :class="{ space: isShow == true }">
        <div class="content-top">
          <div class="name">姓名</div>
          <div class="sex">性别</div>
          <div class="age">年龄</div>
          <div class="education">学历</div>
          <div class="work">学前岗位</div>
          <div class="oldSalay">学前薪资</div>
          <div class="newSalay">学后薪资</div>
          <div class="salary-increase">薪资涨幅</div>
          <div class="company">就业公司</div>
        </div>

        <div class="item" v-for="(item, index) in list" :key="index">
          <div class="name">{{ item.name }}</div>
          <div class="sex">{{ item.sex }}</div>
          <div class="age">{{ item.age }}</div>
          <div class="education">{{ item.edu }}</div>
          <div class="work">{{ item.preSchool }}</div>
          <div class="oldSalay">{{ item.preSalary }}</div>
          <div class="newSalay">{{ item.afterSalary }}</div>
          <div class="salary-increase">{{ item.salaryIncrease }}</div>
          <div class="company">{{ item.company }}</div>
        </div>
      </div>
      <div class="seat"></div>
    </div>
    <!-- <div class="hiddent-box" @click="isShow = !isShow">
      {{ !isShow ? "查看全部" : "收起全部" }}
      <img
        :class="{ 'img-rotate': isShow }"
        src="../../../assets/coursePage/ai/box11/open.png"
        alt
      />
    </div> -->

    <!-- <div class="tip">*数据来源：博学谷就业中心人工智能学科就业数据</div> -->
  </div>
</template>

<script>
import pageTitle from "../common/pageTitle.vue";
export default {
  components: {
    pageTitle,
  },
  data() {
    return {
      isShow: false,
      list: [
        {
          name: "王同学",
          sex: "女",
          age: "26",
          edu: "本科",
          preSchool: "运营",
          preSalary: "12000",
          afterSalary: "15000",
          salaryIncrease: "25.00%",
          company: "北京**科技有限公司",
        },
        {
          name: "张同学",
          sex: "男",
          age: "24",
          edu: "大专",
          preSchool: "学前辅导",
          preSalary: "12000",
          afterSalary: "15000",
          salaryIncrease: "25.00%",
          company: "北京**科技有限公司",
        },
        {
          name: "陈同学",
          sex: "女",
          age: "26",
          edu: "大专",
          preSchool: "平面设计",
          preSalary: "8000",
          afterSalary: "15000",
          salaryIncrease: "88.00%",
          company: "北京**科技有限公司",
        },
        {
          name: "富同学",
          sex: "男",
          age: "27",
          edu: "本科",
          preSchool: "规划管理",
          preSalary: "13000",
          afterSalary: "23000",
          salaryIncrease: "77.00%",
          company: "北京**致远科技有限公司",
        },
        {
          name: "李同学",
          sex: "女",
          age: "25",
          edu: "大专",
          preSchool: "出纳",
          preSalary: "6000",
          afterSalary: "15000",
          salaryIncrease: "150.00%",
          company: "北京**夏迅联信息技术有限公司",
        },
        {
          name: "周同学",
          sex: "男",
          age: "26",
          edu: "大专",
          preSchool: "技术",
          preSalary: "9000",
          afterSalary: "14300",
          salaryIncrease: "59.00%",
          company: "恒生**(广东)科技有限公司",
        },
        {
          name: "商同学",
          sex: "女",
          age: "32",
          edu: "硕士",
          preSchool: "策划",
          preSalary: "9000",
          afterSalary: "25000",
          salaryIncrease: "178.00%",
          company: "北京**国际信息技术有限公司",
        },
        {
          name: "李同学",
          sex: "女",
          age: "25",
          edu: "本科",
          preSchool: "包装设计",
          preSalary: "12000",
          afterSalary: "14000",
          salaryIncrease: "17.00%",
          company: "北京**软件科技有限公司",
        },
        {
          name: "江同学",
          sex: "女",
          age: "28",
          edu: "本科",
          preSchool: "社群运营",
          preSalary: "12000",
          afterSalary: "15000",
          salaryIncrease: "25.00%",
          company: "北京**科技有限公司",
        },
        {
          name: "安同学",
          sex: "男",
          age: "24",
          edu: "本科",
          preSchool: "销售",
          preSalary: "18000",
          afterSalary: "20000",
          salaryIncrease: "11.00%",
          company: "北京**优品科技有限公司",
        },
        // {
        //   name: "胡同学",
        //   sex: "男",
        //   age: "23",
        //   edu: "本科",
        //   preSchool: "前端",
        //   preSalary: "6000",
        //   afterSalary: "16000",
        //   salaryIncrease: "167.00%",
        //   company: "**空间技术（深圳）有限公司",
        // },
        // {
        //   name: "刘同学",
        //   sex: "女",
        //   age: "27",
        //   edu: "大专",
        //   preSchool: "客服",
        //   preSalary: "8000",
        //   afterSalary: "14000",
        //   salaryIncrease: "75.00%",
        //   company: "北京**科技有限公司",
        // },
        // {
        //   name: "王同学",
        //   sex: "女",
        //   age: "29",
        //   edu: "本科",
        //   preSchool: "UI",
        //   preSalary: "16000",
        //   afterSalary: "20000",
        //   salaryIncrease: "25.00%",
        //   company: "北京**互联网技术有限公司",
        // },
        // {
        //   name: "杜同学",
        //   sex: "男",
        //   age: "27",
        //   edu: "本科",
        //   preSchool: "开发",
        //   preSalary: "10000",
        //   afterSalary: "13000",
        //   salaryIncrease: "30.00%",
        //   company: "北京**国信科技有限公司",
        // },
        // {
        //   name: "陈同学",
        //   sex: "女",
        //   age: "25",
        //   edu: "本科",
        //   preSchool: "后期制作",
        //   preSalary: "5000",
        //   afterSalary: "12500",
        //   salaryIncrease: "150.00%",
        //   company: "上海**互联网科技有限公司",
        // },
        // {
        //   name: "靳同学",
        //   sex: "女",
        //   age: "24",
        //   edu: "大专",
        //   preSchool: "老师",
        //   preSalary: "6000",
        //   afterSalary: "18000",
        //   salaryIncrease: "200.00%",
        //   company: "**动力信息技术有限公司",
        // },
        // {
        //   name: "兰同学",
        //   sex: "男",
        //   age: "27",
        //   edu: "本科",
        //   preSchool: "市场营销",
        //   preSalary: "8000",
        //   afterSalary: "15000",
        //   salaryIncrease: "88.00%",
        //   company: "北京**科技有限公司",
        // },
        // {
        //   name: "年同学",
        //   sex: "男",
        //   age: "30",
        //   edu: "硕士",
        //   preSchool: "研究员",
        //   preSalary: "20000",
        //   afterSalary: "23000",
        //   salaryIncrease: "15.00%",
        //   company: "北京**互联网信息服务有限公司",
        // },
        // {
        //   name: "张同学",
        //   sex: "女",
        //   age: "26",
        //   edu: "本科",
        //   preSchool: "销售经理",
        //   preSalary: "12000",
        //   afterSalary: "18000",
        //   salaryIncrease: "50.00%",
        //   company: "**股份有限公司",
        // },
        // {
        //   name: "尚同学",
        //   sex: "女",
        //   age: "29",
        //   edu: "本科",
        //   preSchool: "课程顾问",
        //   preSalary: "8000",
        //   afterSalary: "18000",
        //   salaryIncrease: "125.00%",
        //   company: "**信息技术股份有限公司",
        // },
        // {
        //   name: "王同学",
        //   sex: "男",
        //   age: "34",
        //   edu: "本科",
        //   preSchool: "市场经理",
        //   preSalary: "10000",
        //   afterSalary: "14000",
        //   salaryIncrease: "40.00%",
        //   company: "**国科控股有限公司",
        // },
        // {
        //   name: "佟同学",
        //   sex: "男",
        //   age: "27",
        //   edu: "本科",
        //   preSchool: "管理",
        //   preSalary: "13000",
        //   afterSalary: "16000",
        //   salaryIncrease: "23.00%",
        //   company: "中国**科技集团有限公司",
        // },
        // {
        //   name: "李同学",
        //   sex: "男",
        //   age: "33",
        //   edu: "本科",
        //   preSchool: "职员",
        //   preSalary: "9000",
        //   afterSalary: "15000",
        //   salaryIncrease: "67.00%",
        //   company: "河南**电子科技有限公司",
        // },
        // {
        //   name: "朱同学",
        //   sex: "女",
        //   age: "36",
        //   edu: "大专",
        //   preSchool: "设计",
        //   preSalary: "8000",
        //   afterSalary: "20000",
        //   salaryIncrease: "150.00%",
        //   company: "北京**数字信息技术有限公司",
        // },
        // {
        //   name: "朱同学",
        //   sex: "女",
        //   age: "23",
        //   edu: "大专",
        //   preSchool: "会计",
        //   preSalary: "5000",
        //   afterSalary: "14000",
        //   salaryIncrease: "180.00%",
        //   company: "北京**智远信息有限公司",
        // },
      ],
      scroll: 0,
      // showList: false,
    };
  },
  computed: {
    styleVar() {
      return {
        "--box-left": this.scroll + "px",
      };
    },
  },
  mounted() {},
  methods: {
    handleScroll() {
      let dom = this.$refs.content.getBoundingClientRect();
      let left = Math.abs(parseInt(dom.x)) / 30;
      if (left >= 1) {
        this.scroll = left;
      } else {
        this.scroll = 0;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.box9 {
  position: relative;
  padding: 80px 0px 66px;
  width: 100%;
  background: url("../../../assets/coursePage/pm/box9/bgc.png") no-repeat;
  background-size: cover;
  overflow: hidden;
  .seat {
    width: 32px;
    flex-shrink: 0;
  }
  .left-box {
    position: absolute;
    top: 240px;
    left: 0px;
    // background: #fff;
    // border-radius: 24px;
    box-shadow: 8px 0px 16px 0px rgba(64, 128, 255, 0.06);
    div {
      width: 100%;
      height: 97px;
      line-height: 80px;
      text-align: center;
      border-radius: 24px 24px 0px 0px;
      background: #fff;
      text-align: center;
      font-size: 24px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #4e5969;
      border-bottom: 2px solid rgba(232, 243, 255, 0.8);
      box-sizing: border-box;
      &:first-child {
        background: linear-gradient(180deg, #ceecff 0%, #f4faff 100%);
        font-size: 24px;
        font-family: PingFangSC-Medium;
        color: #1d2129;
        font-weight: 500;
        border-bottom: none;
      }
      &:last-child {
        border-bottom: none;
      }
    }
  }

  .scorll-box {
    position: absolute;
    left: 50%;
    bottom: 144px;
    transform: translate(-50%, 0px);
    width: 40px;
    height: 6px;
    background: rgba(75, 132, 250, 0.16);
    border-radius: 3px;
    .scorll-block {
      position: absolute;
      left: var(--box-left);
      width: 20px;
      height: 6px;
      background: #4b84fa;
      border-radius: 3px;
    }
  }

  .content-box {
    display: flex;
    width: 100%;
    padding: 0px 0 0 32px;
    padding-bottom: 22px;
    overflow-x: auto;
    box-sizing: border-box;
  }
  .content-box::-webkit-scrollbar {
    display: none;
    width: 0 !important;
    height: 0 !important;
    color: transparent;
  }

  .content {
    flex-shrink: 0;
    margin-top: 48px;
    width: 1380px;
    background: #ffffff;
    box-shadow: 0px 8px 24px 0px rgba(64, 128, 255, 0.12);
    border-radius: 24px;
    overflow-x: hidden;
    // overflow-y: scroll;
    .salary-increase {
      width: 160px;
    }
    .sex {
      width: 96px;
    }
    .age {
      width: 96px;
    }

    .major {
      width: 152px;
    }

    .education {
      width: 116px;
    }

    .day {
      width: 128px;
    }

    .name {
      width: 120px;
    }

    .work {
      width: 144px;
    }

    .oldSalay {
      width: 144px;
    }
    .newSalay {
      width: 144px;
    }
    .company {
      width: 350px;
    }

    .content-top {
      display: flex;
      width: 100%;
      height: 80px;
      line-height: 80px;
      text-align: center;
      border-radius: 24px 24px 0px 0px;
      background: #959dfe;
      font-size: 24px;
      font-family: PingFangSC-Medium;
      font-weight: 500;
      color: #ffffff;
    }

    .item {
      display: flex;
      width: 100%;
      height: 80px;
      line-height: 80px;
      text-align: center;
      border-radius: 24px 24px 0px 0px;
      background: #fff;
      font-size: 24px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #4e5969;
      border-bottom: 2px solid rgba(232, 243, 255, 0.8);

      .newSalay {
        color: #5f59ff;
      }
    }
  }

  .tip {
    margin-top: 48px;
    font-size: 22px;
    font-family: PingFang SC;
    font-weight: 400;
    text-align: center;
    color: #b9c8d9;
    line-height: 36px;
  }
}
</style>
